module.exports = __webpack_public_path__ + "img/fontawesome-webfont.65bcbc89.svg";